(function () {
  let mediaQuery = window.matchMedia("(max-width: 600px)");
  if (mediaQuery.matches) {
    const swiperBrand = new Swiper('[data-selector="brand-slider"]', {
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
      },     
    });
  }
})();
